export default __webpack_public_path__ + "static/TC_Step_1-733bc9377b2e48bac76a0194b39b272e.svg";